import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import { minDate } from "../../Constants/Constants";

const AddPrivateOrderDispatch = ({
  govt_order_details_id,
  formRef,
  getData,
  orderId,
  setOrderId,
  productName,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [selectCompanyId, setSelectCompanyId] = useState("");
  const [productId, setProductId] = useState("");
  const [yardId, setYardID] = useState("");
  const [closingStockInYard, setClosingStockInYard] = useState("");
  const [vehicle, setVehicle] = useState([]);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [tripExistId, setTripExistId] = useState("");
  const [existFlag, setExistFlag] = useState(false);
  const [orderNumbers, setOrderNumbers] = useState([
    {
      company_id: "",
      yard_id: "",
      product_name_id: "",
      dispatch_qty: "",
      p_damage_stock: 0,
      p_shortage_stock: 0,
      p_over_stock: 0,
    },
  ]);
  const [product, setProduct] = useState(Array(orderNumbers.length).fill([]));
  const [yard, setYard] = useState(Array(orderNumbers.length).fill([]));
  const [rowAddData, setRowAddData] = useState({
    order_number_id: "",
    dispatch_date: "",
    gp_number: "",
    invoice_date: "",
    invoice_number: "",
    vehicle_number: "",
    invoice_qty: "",
    remarks: "",
  });
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getVehicle = async () => {
    const BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setVehicle(result.data);
    } else {
      setVehicle([]);
    }
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const handleVehicleChange = (e) => {
    setVehicleNumber(e.target.value);
  };

  const addOrderNumberRow = () => {
    setOrderNumbers([
      ...orderNumbers,
      {
        company_id: "",
        yard_id: "",
        product_name_id: "",
        dispatch_qty: "",
        p_damage_stock: 0,
        p_shortage_stock: 0,
        p_over_stock: 0,
      },
    ]);
    setSelectCompanyId(""); // Reset selectCompanyId to empty string
    setProductId(""); // Reset productId to empty string
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };
  const removeOrderNumberRow = (index) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers.splice(index, 1);
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleCompanyChange = (e, index) => {
    setSelectCompanyId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].company_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
    singleYardDetails(e, index);
    getProductDetails(e, index);
  };

  function resetFields() {
    setRowAddData({
      order_number_id: "",
      dispatch_date: "",
      gp_number: "",
      invoice_date: "",
      invoice_number: "",
      vehicle_number: "",
      invoice_qty: "",
      remarks: "",
    });
    // setOrderId("");
    setProduct([]);
    setYardID("");
    setSelectCompanyId("");
    setProductId("");
    setClosingStockInYard("");
    setTripExistId("");
    setOrderNumbers([
      {
        company_id: "",
        yard_id: "",
        product_name_id: "",
        dispatch_qty: "",
        p_damage_stock: 0,
        p_shortage_stock: 0,
        p_over_stock: 0,
      },
    ]);
    setVehicleNumber("");
  }

  const getProductDetails = async (e, index) => {
    const selectedCompanyId = e.target.value;
    const BASE_URL = SERVER_URL + `/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
      }),
    });
    const result = await res.json();
    // setProduct(result.data);
    if (res.ok) {
      const updatedProducts = [...product];
      updatedProducts[index] = result.data;
      setProduct(updatedProducts);
    } else {
      setProduct([]);
    }
  };

  const handleProductChange = (e, index) => {
    setProductId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].product_name_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const singleYardDetails = async (e, index) => {
    const selectedCompanyId = orderNumbers[index].company_id;
    const BASE_URL = `${SERVER_URL}/api/com-yard/single-company-yards/${user_id}/${selectedCompanyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setYard(result.data);
      const updatedYards = [...yard];
      updatedYards[index] = result.data;
      setYard(updatedYards);
    } else {
      setYard([]);
    }
  };

  const getSingleYardDetailClosing = async () => {
    const BASE_URL = `${SERVER_URL}/api/yard-details/single-yard-details/${user_id}?company_id=${selectCompanyId}&product_name_id=${productId}&yard_id=${yardId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setClosingStockInYard(result.data);
    } else {
      setClosingStockInYard("");
    }
  };

  const getTripExist = async () => {
    const BASE_URL = `${SERVER_URL}/api/trips/trip-exist/${user_id}?vehicle_details_id=${vehicleNumber}&dispatch_date=${rowAddData.dispatch_date}&status=${true}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      toast.dismiss();
      setTripExistId(result.data.id);
      setExistFlag(true);
    } else {
      setTripExistId("");
      setExistFlag(false);
      toast.error(result.message);
    }
  };
  useEffect(() => {
    if (yardId) {
      getSingleYardDetailClosing();
    }
  }, [yardId, productId, selectCompanyId]);

  useEffect(() => {
    if (vehicleNumber && rowAddData.dispatch_date) {
      getTripExist();
    }
  }, [vehicleNumber, rowAddData.dispatch_date]);

  const handleYardChange = (e, index) => {
    setYardID(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].yard_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleQtyChange = (e, index, field) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index][field] = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleSave = (e) => {
    e.preventDefault();
    console.log(orderNumbers);
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      order_number_id,
      dispatch_date,
      gp_number,
      invoice_qty,
      invoice_date,
      invoice_number,
      remarks,
    } = rowAddData;
    if (!existFlag) {
      toast.error(
        "Please check the existence of trip over the dispatch date and vehicle number"
      );
      return;
    }

    let BASE_URL =
      SERVER_URL + `/api/private-dispatch/private-order-dispatch/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        private_order_party_id: orderId,
        vehicle_details_id: vehicleNumber,
        dispatch_details: orderNumbers,
        invoice_qty,
        dispatch_date,
        gp_number,
        invoice_date,
        invoice_number,
        remarks,
        trip_id: tripExistId,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      resetFields();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Private Order Dispatch
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div style={{ textAlign: "center" }} className="mb-4">
                <h6>
                  <i className="fa fa-info-circle"></i> Stock in Yard for
                  selected details :{" "}
                  <span style={{ fontSize: "18px" }}>
                    {closingStockInYard
                      ? closingStockInYard?.p_closing_stock
                      : 0}
                  </span>
                </h6>
              </div>
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                      ref={formRef}
                    >
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="gp_number">GP Number</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="gp_number"
                                id="gp_number"
                                placeholder="GP Number"
                                onChange={handleChange}
                                //   onChange={(event) =>
                                //     handleChangeInput(index, event)
                                //   }
                                value={rowAddData.gp_number}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Date">Dispatch Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="dispatch_date"
                                id="Date"
                                placeholder="dispatch_date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={rowAddData.dispatch_date}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="invoice_date">Invoice Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="invoice_date"
                                id="invoice_date"
                                placeholder="Invoice Date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={rowAddData.invoice_date}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="invoice_qty">Invoice Qty</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="invoice_qty"
                                id="invoice_qty"
                                placeholder="Invoice Qty"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={rowAddData.invoice_qty}
                                required
                                autoComplete="off"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Invoice">Invoice Number</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="invoice_number"
                                id="Invoice"
                                placeholder="Invoice Number"
                                onChange={handleChange}
                                value={rowAddData.invoice_number}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Vehicle">Vehicle Number</label>
                            <select
                              className="form-control form-control-lg"
                              value={vehicleNumber}
                              onChange={handleVehicleChange}
                              id="Vehicle"
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => (
                                  <option
                                    key={id}
                                    value={item.id}
                                  >{`${item.vehicle_number}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="remarks">Remarks</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="remarks"
                                id="remarks"
                                placeholder="Remarks"
                                onChange={handleChange}
                                value={rowAddData.remarks}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {orderNumbers &&
                        orderNumbers?.length > 0 &&
                        orderNumbers?.map((order, index) => {
                          return (
                            <div key={index} className="row">
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="Company">Company Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.company_id}
                                    onChange={(e) =>
                                      handleCompanyChange(e, index)
                                    }
                                    id="Company"
                                  >
                                    <option value="">Select Company</option>
                                    {company &&
                                      company?.length > 0 &&
                                      company?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.company_name}, ${item.location}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="product">Product Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.product_name_id}
                                    onChange={(e) =>
                                      handleProductChange(e, index)
                                    }
                                    disabled={!selectCompanyId}
                                    id="product"
                                  >
                                    <option value="">Select Product</option>
                                    {product &&
                                      product[index]
                                        ?.filter(
                                          (item) => item.size == productName
                                        )
                                        ?.map((item, id) => (
                                          <option
                                            key={id}
                                            value={item.id}
                                          >{`${item.size}`}</option>
                                        ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="yard">Yard Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.yard_id}
                                    onChange={(e) => handleYardChange(e, index)}
                                    disabled={!selectCompanyId}
                                    id="yard"
                                  >
                                    <option value="">Select yard</option>
                                    {yard &&
                                      yard[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.yard_name}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="QTY">Dispatch Quantity</label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={order.dispatch_qty}
                                      name="dispatch_qty"
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "dispatch_qty"
                                        )
                                      }
                                      required
                                      placeholder="Dispatch Quantity"
                                      id="QTY"
                                      min="0"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="p_damage_stock">
                                    Damage Quantity
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={order.p_damage_stock}
                                      name="p_damage_stock"
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "p_damage_stock"
                                        )
                                      }
                                      required
                                      placeholder="Damage Quantity"
                                      id="p_damage_stock"
                                      min="0"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="p_shortage_stock">
                                    Shortage Quantity
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={order.p_shortage_stock}
                                      name="p_shortage_stock"
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "p_shortage_stock"
                                        )
                                      }
                                      required
                                      placeholder="Shortage Quantity"
                                      id="p_shortage_stock"
                                      min="0"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label htmlFor="p_over_stock">
                                    Over Stock Quantity
                                  </label>
                                  <div className="input-group">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={order.p_over_stock}
                                      name="p_over_stock"
                                      onChange={(e) =>
                                        handleQtyChange(
                                          e,
                                          index,
                                          "p_over_stock"
                                        )
                                      }
                                      required
                                      placeholder="Over Stock/Goods Return Quantity"
                                      id="p_over_stock"
                                      min="0"
                                    />
                                    <span className="input-group-append ml-2">
                                      <div className="col-md-2">
                                        {index > 0 ? (
                                          <button
                                            type="button"
                                            title="Remove"
                                            className="btn btn-outline-danger btn-rounded btn-icon"
                                            onClick={() =>
                                              removeOrderNumberRow(index)
                                            }
                                          >
                                            <span className="mdi mdi-close-thick"></span>
                                          </button>
                                        ) : (
                                          <button
                                            type="button"
                                            disabled
                                            className="btn btn-outline-danger btn-rounded btn-icon"
                                          >
                                            <i className="mdi mdi-close" />
                                          </button>
                                        )}
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      <span className="input-group-append ml-2">
                        <button
                          className="btn btn-primary mt-3"
                          type="button"
                          onClick={addOrderNumberRow}
                        >
                          Add More
                        </button>
                      </span>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPrivateOrderDispatch;
